/* Le calcul du ski finder et du Size Guide — doc de contenus §10.1 et §10.2.
 * Voir tools/verifie-calcul-finder.mjs.
 *
 * Script classique, sans DOM, consommé par assets/simply-finder.js via
 * globalThis.SimplyFinderCalcul. Les chiffres et les règles viennent de la
 * boutique (grilles simply_grille_taille, terrains simply_finder_terrain) ; ce
 * fichier ne porte que la façon de les appliquer. */
const NIVEAUX = ['getting-there', 'confident', 'off-piste', 'expert'];
const STYLES = ['playful', 'balanced', 'fast'];

/* Une fourchette de la grille ; un maximum vide veut dire « and up ». */
function dans(min, max, v) {
  return v >= min && (max === null || max === undefined || v <= max);
}

/* Les longueurs d'un modèle dont la fourchette contient la taille et le poids. */
function longueurs(grille, modele, taille, poids) {
  return grille
    .filter((l) => l.modele === modele
      && dans(l.taille_min, l.taille_max, taille)
      && dans(l.poids_min, l.poids_max, poids))
    .map((l) => l.longueur)
    .sort((a, b) => a - b);
}

/* Entre deux longueurs (§10.1) : getting there ou playful → courte, fast →
 * longue, sinon les deux. Getting there l'emporte sur fast (Q3). */
function tranche(candidates, niveau, style) {
  if (candidates.length < 2) return candidates;
  const courte = candidates[0];
  const longue = candidates[candidates.length - 1];
  if (niveau === 'getting-there' || style === 'playful') return [courte];
  if (style === 'fast') return [longue];
  return [courte, longue];
}

/* Le modèle du terrain, et le second quand ses conditions tiennent (§10.2). */
function modeles(terrains, cle, niveau, style) {
  const t = terrains.find((x) => x.cle === cle);
  if (!t) return [];
  const okStyle = !t.si_style || t.si_style === style;
  const okNiveau = !t.si_niveau_max || NIVEAUX.indexOf(niveau) <= NIVEAUX.indexOf(t.si_niveau_max);
  return t.secondaire && okStyle && okNiveau ? [t.principal, t.secondaire] : [t.principal];
}

function recommande(donnees, rep) {
  const mods = rep.modele ? [rep.modele] : modeles(donnees.terrains || [], rep.terrain, rep.niveau, rep.style);
  const options = [];
  for (const m of mods) {
    let ls = tranche(longueurs(donnees.grille || [], m, rep.taille, rep.poids), rep.niveau, rep.style);
    // Deux modèles : une longueur chacun, la courte si le style n'a pas tranché (écart 4).
    if (mods.length > 1) ls = ls.slice(0, 1);
    for (const l of ls) {
      options.push({ modele: m, longueur: l, sens: ls.length > 1 ? (l === ls[0] ? 'courte' : 'longue') : null });
    }
  }
  // Sans longueur pour le modèle principal, on ne propose pas le second à sa place (écart 3).
  if (!options.length || options[0].modele !== mods[0]) return { statut: 'hors-grille', options: [] };
  return { statut: options.length === 1 ? 'un' : 'deux', options };
}

globalThis.SimplyFinderCalcul = { recommande, NIVEAUX, STYLES };
